define('entities/admin/api_stats',[
  'app',
  'jquery',
  'underscore',
  'settings'
], function (
  App,
  $,
  _,
  Settings
) {
  'use strict';

  var API = {
    url: function (relative, params) {
      // Drop unset filters rather than sending "null". Settings.url does not
      // encode values, and endpoint patterns ("/v2/x/{secId}") or client
      // families ("Browser (other)") would be rejected by Tomcat with a 400.
      var clean = {};
      _.each(params || {}, function (v, k) {
        if (v !== null && v !== undefined && v !== '') {
          clean[k] = encodeURIComponent(v);
        }
      });
      return Settings.url('compuzz2', 'v2/api-stats/' + relative, clean);
    },
    blockUrl: function (relative, params) {
      var clean = {};
      _.each(params || {}, function (v, k) {
        if (v !== null && v !== undefined && v !== '') {
          clean[k] = encodeURIComponent(v);
        }
      });
      return Settings.url('compuzz2', 'v2/api-block/' + relative, clean);
    }
  };

  function jsonGet(url) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: url,
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  }

  /** Rejects with the server message ({message}) on 400 / 409. */
  function jsonSend(type, url, body) {
    var defer = $.Deferred();
    $.ajax({
      type: type,
      url: url,
      contentType: 'application/json',
      data: body ? JSON.stringify(body) : undefined,
      success: function (data) { defer.resolve(data); },
      error: function (xhr) {
        var message = xhr.responseJSON && xhr.responseJSON.message;
        defer.reject(message || (xhr.status + ' ' + (xhr.statusText || '')));
      }
    });
    return defer.promise();
  }

  /** {canView, allAccounts, canBlock}; never rejects (a failure means no access). */
  App.reqres.setHandler('apiStats:access', function () {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.url('access'),
      global: false,
      success: function (data) {
        defer.resolve({
          canView: !!(data && data.canView === true),
          allAccounts: !!(data && data.allAccounts === true),
          canBlock: !!(data && data.canBlock === true)
        });
      },
      error: function () { defer.resolve({ canView: false, allAccounts: false, canBlock: false }); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('apiStats:summary', function (params) {
    return jsonGet(API.url('summary', params));
  });

  /** params.groupBy: ACCOUNT | USER | ENDPOINT | CLIENT; params.sort: CALLS | ERRORS | AVG_MS | MAX_MS | TOTAL_MS */
  App.reqres.setHandler('apiStats:breakdown', function (params) {
    return jsonGet(API.url('breakdown', params));
  });

  App.reqres.setHandler('apiStats:timeline', function (params) {
    return jsonGet(API.url('timeline', params));
  });

  // Notifications pushed by the backend to the dashboards (same screen, other mode).
  App.reqres.setHandler('apiStats:notifications:summary', function (params) {
    return jsonGet(API.url('notifications/summary', params));
  });

  /** params.groupBy: ACCOUNT | TYPE | SOURCE | TRIGGER; params.sort: CALLS | ERRORS | AVG_MS | MAX_MS | TOTAL_MS | BYTES */
  App.reqres.setHandler('apiStats:notifications:breakdown', function (params) {
    return jsonGet(API.url('notifications/breakdown', params));
  });

  App.reqres.setHandler('apiStats:notifications:timeline', function (params) {
    return jsonGet(API.url('notifications/timeline', params));
  });

  // ---------- blocking (DEV TEAM super users) ---------------------------

  App.reqres.setHandler('apiBlock:rules', function () {
    return jsonGet(API.blockUrl('rules'));
  });

  /** rule: {type: IP | ORIGIN | HOST, pattern, note, expiresAt (epoch ms or null), active} */
  App.reqres.setHandler('apiBlock:create', function (rule) {
    return jsonSend('POST', API.blockUrl('rules'), rule);
  });

  App.reqres.setHandler('apiBlock:update', function (id, rule) {
    return jsonSend('PUT', API.blockUrl('rules/' + id), rule);
  });

  App.reqres.setHandler('apiBlock:delete', function (id) {
    return jsonSend('DELETE', API.blockUrl('rules/' + id));
  });

  /** params: {type, from, to, search, limit} */
  App.reqres.setHandler('apiBlock:sources', function (params) {
    return jsonGet(API.blockUrl('sources', params));
  });

  /** {ip, origin, host} of the current browser, as the server resolves them. */
  App.reqres.setHandler('apiBlock:whoami', function () {
    return jsonGet(API.blockUrl('whoami'));
  });
});

